<template>
  <div
    v-if="shouldDisplayBanner"
    class="inscribe-warning-banner w-100 text-center i-px-10 i-py-4 i-text-body-2 i-radius-3xl"
  >
    Workspace: <b> {{ currentOrg }} </b>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isProduction } from './../environment';

export default {
  data: () => ({
    internalOrgIds: [
      'b1f3feeb-60eb-43c5-ae3d-e89150f11848',
      'ab865fd1-4cad-4c22-9863-4c91e533a746',
      'f07cca0b-da3e-4d13-b343-13d203a151a1',
      'c4850812-904f-434a-9584-97b7889f95b7', // Intuit AI Compliance Analyst Testing
      '1e76d945-8f40-44db-a80b-8d6eb5ca29c1', // Business Compliance Agent Testing
    ],
  }),
  computed: {
    ...mapState(['currentUser', 'workspaces']),
    currentOrg() {
      const orgName = this.currentUser?.organisation?.name || '';
      const webSearchEnabled =
        this.currentUser?.organisation?.web_search_enabled;

      return webSearchEnabled ? `${orgName} - Web search enabled` : orgName;
    },
    shouldDisplayBanner() {
      return (
        isProduction &&
        this.currentUser.email.endsWith('@inscribe.ai') &&
        !this.currentUser?.organisation?.name?.toLowerCase().includes('demo') &&
        !this.internalOrgIds.includes(this.currentUser?.organisation?.id)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.inscribe-warning-banner {
  position: fixed;
  top: 4px;
  left: 50%;
  width: auto;
  transform: translateX(-50%);
  z-index: 1000;
  background-color: red;
  color: white;
}
</style>
